import React, { useState } from "react";
import PropTypes from "kf-proptypes/widgets";

import { isEmpty } from "base/utils";

import { SearchWidget } from "./search.widget.jsx";
import { OverflowText } from "@widgets/datadisplay/index.jsx";
import { DropDownWrapper, NoResultsFound } from "./index.jsx";

import styles from "./singleselect.css";

import ActiveIcon from "../active_right.svg";

export function SingleSelectWidget(props) {
  let {
    onSearch,
    onChange = null,
    dataSource = [],
    labelRenderer = null,
    value,
    searchAutoFocus = false
  } = props;
  let [searchText, setSearchText] = useState("");

  return (
    <div>
      {onSearch && (
        <SearchWidget
          onSearch={(value) => {
            setSearchText(value);
            onSearch(value);
          }}
          searchAutoFocus={searchAutoFocus}
        />
      )}
      <DropDownWrapper>
        <>
          {dataSource &&
            dataSource.map((item, index) => {
              if (!item) {
                return null;
              }
              return (
                <SingleSelectListItem
                  item={item}
                  key={index}
                  active={JSON.stringify(value) === JSON.stringify(item)}
                  labelRenderer={labelRenderer}
                  onClick={onChange}
                />
              );
            })}
          {isEmpty(dataSource) && <NoResultsFound searchText={searchText} />}
        </>
      </DropDownWrapper>
    </div>
  );
}

SingleSelectWidget.propTypes = {
  onSearch: PropTypes.func,
  onChange: PropTypes.func,
  dataSource: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.shape({
      _id: PropTypes.string,
      Kind: PropTypes.string,
      Email: PropTypes.string,
      Name: PropTypes.string,
      key: PropTypes.string,
      label: PropTypes.string
    })
  ]),
  labelRenderer: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.shape({
      _id: PropTypes.string,
      Kind: PropTypes.string,
      Email: PropTypes.string,
      Name: PropTypes.string,
      key: PropTypes.string,
      label: PropTypes.string
    })
  ]),
  searchAutoFocus: PropTypes.bool
};

export function SingleSelectListItem(props) {
  let { item, labelRenderer, onClick, active = false, className = "" } = props;
  let { disabled = false } = item;
  return (
    <div
      onClick={() => {
        if (onClick) {
          if (!disabled) {
            onClick(item);
          }
        }
      }}
      className={`${disabled && styles.disabled} ${
        styles.dropDownItem
      } ${className}`}
    >
      {
        <p className={`base ${styles.dropDownItemTxt}`}>
          <OverflowText line={1}>{labelRenderer(item)}</OverflowText>
        </p>
      }
      {active && <ActiveIcon />}
    </div>
  );
}

SingleSelectListItem.propTypes = {
  item: PropTypes.oneOfType([
    PropTypes.shape({
      _id: PropTypes.string,
      Kind: PropTypes.string,
      Email: PropTypes.string,
      Name: PropTypes.string,
      key: PropTypes.string,
      label: PropTypes.string
    }),
    PropTypes.string
  ]),
  labelRenderer: PropTypes.func,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  className: PropTypes.string
};
